import React from "react";

const ProgressIndicatorCardSkeleton = () => {
  return (
    <div className="bg-white lg:sticky lg:top-24 h-fit border border-light-blue rounded-[1.25rem] p-6 shadow-sm w-full lg:w-[23.6875rem] lg:max-w-[23.6875rem] min-h-[18.75rem] animate-pulse">
      <div className="w-40 h-6 mb-8 bg-gray-200 rounded"></div>

      <div className="flex flex-col">
        {[...Array(3)].map((_, index) => (
          <React.Fragment key={index}>
            <div className="flex items-center gap-4 relative max-h-[2.375rem] h-[2.375rem]">
              <div className="flex items-center gap-8">
                <div className="flex items-center gap-3">
                  <div className="relative z-10 flex items-center justify-center w-[32px] h-[32px] rounded-full bg-gray-200"></div>

                  <div className="flex-1">
                    <div className="flex items-start flex-col gap-[10px]">
                      <div className="w-24 h-4 bg-gray-200 rounded"></div>
                      <div className="w-24 h-4 bg-gray-200 rounded"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-[32px] h-[32px] flex items-center justify-center">
              <div className={`w-6 h-6 rounded-full`} />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicatorCardSkeleton;
